import { createApp } from 'vue'
import App from './App.vue'
import router from './router';
import '../public/assets/css/plugins/icofont.min.css';
import '../public/assets/css/plugins/flaticon.css';
import '../public/assets/css/plugins/font-awesome.min.css';
import '../public/assets/css/plugins/animate.min.css';
import '../public/assets/css/plugins/swiper-bundle.min.css';
import '../public/assets/css/plugins/magnific-popup.css';
import '../public/assets/css/plugins/nice-select.css';
import '../public/assets/css/plugins/apexcharts.css';
import '../public/assets/css/plugins/jqvmap.min.css';
import '../public/assets/css/style.css';
import '../public/assets/css/custom-style.css';

const app = createApp(App);
app.use(router);
app.mount('#app');